import { useState } from 'preact/hooks';
import { usePlayerState } from '../../hooks/usePlayerState';
import { AudioPlayer } from '../AudioPlayer/AudioPlayer';
import { TtsIdleLayout } from './TtsIdleLayout';
import { TtsInfoButton } from './TtsInfoButton';
import { TtsInfoFooter } from './TtsInfoFooter';

export const TtsLayout = () => {
  const [isInfoVisible, setIsInfoVisible] = useState(false);
  const state = usePlayerState();

  const infoButton = (
    <TtsInfoButton onClick={() => setIsInfoVisible((prev) => !prev)} />
  );
  const infoFooter = isInfoVisible ? <TtsInfoFooter /> : null;

  if (state === 'idle') {
    return <TtsIdleLayout infoButton={infoButton} infoFooter={infoFooter} />;
  }

  return (
    <div className="vgp-tts-layout">
      <AudioPlayer actions={infoButton} footer={infoFooter} />
    </div>
  );
};
